/**
 *  AI
 *
 *  Created by Legman on 10/04/2017.
 *
 */

import Common from "./Common";
import RaceCar from "./race/RaceCar";

/**
 * @class
 * @extends RaceCar
 */
export default class AI extends RaceCar {
    /**
     * @param {number} id
     * @param {RaceCarView} view
     */
    constructor(id, view) {
        super(id, view);

        this.acceleration = 3.32;

        /**
         * @type {number}
         * @private
         */
        this._targetX = 0;

        /**
         * @type {number}
         * @private
         */
        this._powerupDesire = 0;

        /**
         * @type {number}
         * @private
         */
        this._baseAccel = 0;
    }

    init() {
        super.init();

        this._targetX = this.offset.x;
        this._powerupDesire = Math.random() * 600;
        this._baseAccel = this.acceleration;

        delay(function() {
            this.applyTargetNoise();
        }, 2 + Math.random() * 4, this);
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        const pos = Common.game.getRacePos(this);
        const cars = Common.game.getCars();
        this.acceleration = this._baseAccel + Math.pow((pos / cars.length) * 0.2, 2);

        const powerup = this.isSeekingPowerup ? this.seekPowerup() : null;

        let target;
        if (powerup) {
            target = powerup.offset.x;
        } else {
            target = this._targetX + this.engine.getAverageTrackCurvature(this.distance) * 8400;
        }

        const width = 640;
        if (Math.abs(target) > width) {
            target = (target / Math.abs(target)) * width;
        }

        const distance = target - this.offset.x;
        const direction = distance / Math.abs(distance);
        const time = 1.6;

        const radius = 280;
        if (distance > radius) {
            this.turnSpeed = direction * this.turnAccel;
        } else {
            this.turnSpeed = direction * (this.turnAccel * Math.min(1, Math.abs(distance / radius)));
        }
        this.turnSpeed /= time;

        this._powerupDesire += this.getPowerupDesireModifier();

        super.update(dt);
    }

    /**
     * @param {number} dt
     */
    updateView(dt) {
        super.updateView(dt);

        let curvature = 4 * this.engine.getAverageTrackCurvature(this.distance, 2);
        curvature = curvature + this.getPerpTo(this.engine.camera.target) * 1.4;
        curvature = curvature + -this.screenPosition.x * 0.0014;
        let gradient = this.engine.getTrackGradient(this.distance) - this.engine.getTrackGradient(this.engine.camera.target.distance);
        this._view.update(
            dt,
            this.distance,
            curvature * 160,
            gradient * 0.6,
            this.velocity,
            this.turnVelocity * 0.08,
            this._jumpOffset
        );
    }

    /**
     * @param powerup
     */
    usePowerup(powerup) {
        super.usePowerup(powerup);

        this._powerupDesire = 0;
    }

    /**
     * @returns {RaceEntity}
     */
    seekPowerup() {
        let minDistance = Number.MAX_SAFE_INTEGER;
        let result = null;
        const powerups = Common.game.getPickups();

        for (let i = 0; i < powerups.length; ++i) {
            const powerup = powerups[i];
            if (!powerup.collected) {
                const dx = Math.abs(powerup.offset.x - this.offset.x);
                const dy = powerup.distance - this.distance;
                if (dy > 0 && dy < 16) {
                    if (dx < minDistance) {
                        result = powerup;
                        minDistance = dx;
                    }
                }
            }
        }
        return result;
    }

    /**
     * @returns {number}
     */
    getOvertakeDesireModifier() {
    }

    /**
     * @returns {number}
     */
    getPowerupDesireModifier() {
        const cars = Common.game.getCars();
        return ((cars.indexOf(this) + 1) / cars.length) * 0.6;
    }

    /**
     */
    applyTargetNoise() {
        this._targetX = p3.Utils.randomInt(1140, -1140);

        delay(function () {
            this.applyTargetNoise();
        }, 4 + Math.random() * 6, this);
    }

    /**
     * @returns {boolean}
     */
    get isSeekingPowerup() {
        return this._powerupDesire > 600;
    }
}